module.exports = __webpack_public_path__ + "img/bg1.4362405b.jpg";